const en = {
  overview: "Overview",
  onlineStore: "Online store",
  builder: "Store builder",
  pages: "Pages",
  navigation: "Navigation",
  media: "Media library",
  languages: "Languages",
  assistant: "AI assistant",
  catalog: "Catalog",
  products: "Products",
  collections: "Collections",
  inventory: "Inventory",
  reviews: "Reviews",
  sales: "Sales",
  orders: "Orders",
  returns: "Returns",
  customers: "Customers",
  discounts: "Discounts",
  growth: "Growth",
  marketing: "Marketing",
  analytics: "Analytics",
  settings: "Settings",
  payments: "Payments",
  shipping: "Shipping",
  taxes: "Taxes",
  checkout: "Checkout",
  domains: "Domains",
  seo: "SEO & redirects",
  team: "Team",
  storeDetails: "Store details",
  publish: "Launch & publish",
  switchStore: "Switch store",
  allStores: "All stores…",
  newStore: "+ Create a new store",
  planBilling: "Plan & billing",
  helpSupport: "Help & support",
  openNav: "Open navigation",
  closeNav: "Close navigation",
  navLabel: "Navigation",
  storeNavLabel: "Store",
  notifications: "Notifications",
  notificationsUnread: "Notifications, {count} unread",
  myStores: "My stores",
  accountSecurity: "Account & security",
  support: "Support",
  platformAdmin: "Platform admin",
  signOut: "Sign out",
  stores: "Stores",
  billing: "Billing",
  accountNav: "Account",
  live: "Live",
  suspended: "Suspended",
  notPublished: "Not published",
  viewStore: "View store ↗",
  preview: "Preview ↗",
  suspendedBanner: "This store was suspended by the platform{reason}. Your data is safe —",
  contactSupport: "contact support",
  publicAddress: "Public address: {url}",
  language: "Language",
  adminOverview: "Overview",
  adminUsers: "Users",
  adminStores: "Stores",
  adminPlans: "Plans",
  adminAi: "AI & credits",
  adminPayments: "Payments",
  adminSupport: "Support",
  adminContent: "Content",
  adminHealth: "System health",
  adminAudit: "Audit log",
  adminEmails: "Email log",
  merchantView: "Merchant view",
  exit: "Exit",
  skipToContent: "Skip to content",
};

export default en;
